import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDataPresentationParam, useDatasourceId } from '@/hooks';
import { useLoadRows_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useSelector } from 'react-redux';
import { getQueryBuilderSteps } from '@/store-selectors';
import { useSaveQuerySteps } from '@/features/query-builder/queriesApiSlice';

export const useRefreshQuery = () => {
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  const dataPresentation = useDataPresentationParam();
  const { page } = useLoadRows_LEGACY();
  const steps = useSelector(getQueryBuilderSteps);
  const [saveQuerySteps, { data }] = useSaveQuerySteps();

  const nextQueryId = data?.queryId;

  const handleRefresh = () => saveQuerySteps(steps, page);

  const dataPresentationPath = dataPresentation ? `/${dataPresentation}` : '';

  const nextUrl = `/datasources/${datasourceId}/queries/${nextQueryId}${dataPresentationPath}`;

  React.useEffect(() => {
    if (nextQueryId) navigate(nextUrl);
  }, [nextQueryId]);

  return handleRefresh;
};
